import $ from 'jquery';

export const enterKeyPressed = (e: any, fn: any) => {
    const code = e.keyCode || e.which;
    if (code === 13 || code === 32) {
        fn();
    }
};

export const isVisible = (node: any) => {
    const coords = node.getBoundingClientRect();

    if (node.disabled || (node.tagName === 'INPUT' && node.type === 'hidden')
    || getComputedStyle(node).visibility === 'hidden') {
      return false;
    }

    if (node.tabIndex === -1) {
      return false;
    }

    if (node.id !== '') {
      if ($('#' + node.id).is(':visible') === true) {
        return true;
      } else {
        return false;
      }
    } else if (node.className && node.className !== '') {
      if (typeof node.className === 'string' || node.className instanceof String) {
        const nodeClasses = '.' + node.className.trim().split(' ').filter(Boolean).join('.');
        if ($(nodeClasses).is(':visible') === true) {
          return true;
        } else {
          return false;
        }
      } else if (node.className && node.className.SVGAnimatedString) {
          return true;
      }
    }

    return (
      coords.top >= 0 &&
      coords.left >= 0 &&
      coords.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      coords.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

export const onKeyDown = (e: any, tabListId: any) => {
  const tabsList = $('#' + tabListId);
  const tab = e.currentTarget.childNodes[0];
  switch (e.which) {
    case 37:
    case 38:
      if (tab.parentNode.previousSibling) {
        tab.parentNode.previousSibling.click();
        tab.parentNode.previousSibling.focus();
      } else {
        const lastTab = tabsList.find("li:last");
        if (lastTab?.length === 1) lastTab.click().focus();
      }
      break;
    case 39:
    case 40:
      if (tab.parentNode.nextSibling) {
        tab.parentNode.nextSibling.click();
        tab.parentNode.nextSibling.focus();
      } else {
        const firstTab = tabsList.find("li:first");
        if (firstTab?.length === 1) firstTab.click().focus();
      }
      break;
  }
};

export const replaceAll = (str: string, strToFind: string, replace: string) => {
      const newStrToFind = strToFind.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
      return str.replace(new RegExp(newStrToFind, 'g'), replace);
};
